export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[]
  }
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    AbstractAnswerInterface: ['AnswerType', 'TemplateAnswerType'],
    BaseAnswerSetInterface: ['AnswerSetType', 'CommentType'],
    BaseAttachmentInterface: ['AnswerSetAttachmentType', 'EntryAttachmentType'],
    BaseReferenceInterface: ['AnswerSetReferenceType', 'EntryReferenceType'],
    EditorInterface: ['ManagingEditorType', 'RegionalEditorType'],
    EditorUnion: ['ManagingEditorType', 'RegionalEditorType'],
    GeometryGenericModelInterface: ['GISRegionType'],
    QuestionPathElement: ['CategoryType', 'GroupType', 'QuestionType'],
    TagInterface: ['EntryTagType', 'GISTagType'],
  },
}
export default result
